/**
 * ChatHistoryButton: STT 음성인식 히스토리 사이드바 토글.
 *
 * v1 원본: RenewalComponents/Buttons/ChatHistoryButton/ChatHistoryButtonPresenter.js
 * v1 CSS: .rtc_new3 .newHeader_btnItem > .newHeader_btn
 */
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';

const ChatHistoryButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector((s) => s.ui);
  const isActive = ui.openSideBar && ui.sidebarContent === 'speech';

  const handleClick = () => {
    if (isActive) {
      dispatch(uiActions.setOpenSideBar(false));
    } else {
      dispatch(uiActions.setSidebarContent('speech'));
    }
  };

  return (
    <div className="newHeader_btnItem">
      <button type="button" className="newHeader_btn" onClick={handleClick}>
        <span className="newHeader_btnIcon icoChatHistory" />
        <p className="newHeader_btnText">대화기록</p>
      </button>
    </div>
  );
};

export default ChatHistoryButton;
